// 프로젝트 전반에서 사용될 상수들

const ENV = process.env;

export const BASE_NAME = ENV.REACT_APP_HOST_ROOT;
export const PUBLIC_URL = ENV.PUBLIC_URL;
export const IMG_URL = `${PUBLIC_URL}/images`;
